// src/components/results/ResultsTabState.jsx

import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import Spinner from "../Spinner";
import RecordingEmptyStateTile from "./RecordingEmptyStateTile";

function ResultsTabState({
  uid,
  loading,
  error,
  rows,
  emptyMode,
  firstRunByVariant,
  children,
  spinnerClassName = "min-h-64 flex items-center justify-center",
  errorClassName = "muted-text text-center space-y-1",
}) {
  const { t } = useTranslation();

  if (!uid || loading) {
    return (
      <div className={spinnerClassName}>
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className={errorClassName}>
        <div>{t("results.failedLoad", "Failed to load results.")}</div>
        {error?.message ? <div>{error.message}</div> : null}
      </div>
    );
  }

  if (!Array.isArray(rows) || !rows.length) {
    return (
      <RecordingEmptyStateTile
        mode={emptyMode}
        firstRunByVariant={firstRunByVariant}
      />
    );
  }

  return children;
}

export default memo(ResultsTabState);
